function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_23",
  "data-name": "Ellipse 23",
  cx: 21,
  cy: 21,
  r: 21,
  fill: "#eeeff3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "insert_drive_file_black_24dp",
  transform: "translate(9 9)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_130",
  "data-name": "Path 130",
  d: "M0,0H24V24H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_131",
  "data-name": "Path 131",
  d: "M6,2A2,2,0,0,0,4.01,4L4,20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8.83a1.966,1.966,0,0,0-.59-1.41L14.58,2.59A1.966,1.966,0,0,0,13.17,2H6Zm7,6V3.5L18.5,9H14A1,1,0,0,1,13,8Z",
  transform: "translate(0 0)",
  fill: "#7d9ef1"
}));

var SvgFileInsideCircle = function SvgFileInsideCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2405",
    "data-name": "Group 2405",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileInsideCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-inside-circle.5b056910.svg";
export { ForwardRef as ReactComponent };